import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { arrowLeftBlack, arrowRight, orangeCalendarIcon } from 'assets/icons';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { getMonth, getYear } from 'date-fns';
import styles from './style.module.css';
import { Box } from '@mui/material';
import MobileContext from 'context/MobileContext';
import { useContext } from 'react';
import { leftArrowCalendar, rightArrowCalendar } from 'assets/newIcons';

const DateRangePicker = ({ freezeDate, setFreezeDate }) => {
  const [open, setOpen] = useState(false);
  const [btnDisable, setbtnDisable] = useState(true);
  const isMobile = useContext(MobileContext);

  const onChangeDate = changeDate => {
    setFreezeDate(changeDate);
  };

  useEffect(() => {
    if (freezeDate !== null) {
      setbtnDisable(false);
    }
  }, [freezeDate]);

  const handleSave = () => {
    setOpen(false);
  };

  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return (
    <div className={styles.container}>
      <div className={styles.input} onClick={() => setOpen(!open)}>
        <div className={styles.dateContainer}>
          <p className={styles.dateContent}>
            {freezeDate
              ? moment(freezeDate, 'YYYY-MM-DD').format('MM/DD/YYYY')
              : 'MM/DD/YYYY'}
          </p>
        </div>
        <img style={{ width: 20, height: 20 }} src={orangeCalendarIcon} alt="" />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={styles.modal}
        open={open}
        disableScrollLock
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            style={{
              display: 'flex',
              flexDirection: 'column',
              backgroundColor: 'white',
              borderRadius: '10px',
            }}
          >
            <DatePicker
              renderCustomHeader={({ date, decreaseMonth, increaseMonth }) => (
                <div className={styles.headerAction}>
                  <div className={styles.popupYearHeading}>
                    <p>
                      {months[getMonth(date)]} {getYear(date)}
                    </p>
                  </div>
                  <div className={styles.arrowWrapper}>
                    <img
                      src={leftArrowCalendar}
                      className={styles.leftArrow}
                      alt=""
                      onClick={decreaseMonth}
                    />
                    <img
                      className={styles.rightArrow}
                      src={rightArrowCalendar}
                      alt=""
                      onClick={increaseMonth}
                    />
                  </div>
                </div>
              )}
              selected={freezeDate}
              minDate={new Date()}
              onChange={onChangeDate}
              fixedHeight
              inline
            />
            <div className={styles.button}>
              <button
                disabled={btnDisable ? true : false}
                style={{ color: btnDisable ? 'grey' : '#FE5000', cursor: 'pointer' }}
                className={styles.saveButton}
                onClick={() => handleSave()}
              >
                Save
              </button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
};

export default DateRangePicker;
